import { render } from "./CheckCircle.vue?vue&type=template&id=09ee4e07"
const script = {}
script.render = render

export default script